import { UTM_PARAMS } from "@/platform/api/constants"
import { deleteCookie, readCookie, setCookie } from "@/platform/browser/cookies"
import { readSessionScoped, writeSessionScoped } from "@/platform/browser/session-store"
import { logger } from "@/platform/observability/logger"

export const getSessionCookie = (key: string): string | null => readCookie(key)

export const getUtmParamSessionCookies = (): Record<string, string> => {
  const result: Record<string, string> = {}

  for (const key of UTM_PARAMS) {
    const value = getSessionCookie(key)
    if (value) {
      result[key] = value
    }
  }

  return result
}

export const setSessionCookie = (key: string, value: string, maxAgeSeconds?: number): void => {
  if (typeof window === "undefined") {
    logger.error("setSessionCookie called on server side", { key })
    return
  }

  try {
    setCookie(key, value, { maxAgeSeconds, sameSite: "Strict" })
  } catch (error) {
    logger.error("Error setting session cookie", { key }, error as Error)
  }
}

export const clearSessionCookie = (key: string): void => {
  if (typeof window === "undefined") {
    logger.error("clearSessionCookie called on server side", { key })
    return
  }

  try {
    deleteCookie(key, { sameSite: "Strict" })
  } catch (error) {
    logger.error("Error clearing session cookie", { key }, error as Error)
  }
}

export const getBrowserSessionId = (): string => {
  const STORAGE_KEY = "nelo_session_id"

  if (typeof window === "undefined") return crypto.randomUUID()

  const existing = readSessionScoped(STORAGE_KEY)
  if (existing) return existing

  const sessionId = crypto.randomUUID()
  writeSessionScoped(STORAGE_KEY, sessionId)
  return sessionId
}
